import { LayoutGrid, List } from "lucide-react";

export function ViewSwitcher({ value, onChange }) {
  const base = "flex h-9 w-10 items-center justify-center rounded-lg transition-colors";
  return (
    <div className="inline-flex rounded-xl border border-slate-200 bg-white p-1" data-testid="view-switcher">
      <button
        type="button"
        onClick={() => onChange("card")}
        data-testid="view-card-btn"
        aria-label="Kart görünümü"
        className={`${base} ${value === "card" ? "bg-violet-600 text-white" : "text-slate-500 hover:bg-slate-100"}`}
      >
        <LayoutGrid className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => onChange("list")}
        data-testid="view-list-btn"
        aria-label="Liste görünümü"
        className={`${base} ${value === "list" ? "bg-violet-600 text-white" : "text-slate-500 hover:bg-slate-100"}`}
      >
        <List className="h-4 w-4" />
      </button>
    </div>
  );
}
